import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConsentService, ConsentSettings } from '../../services/consent.service';
import { Router } from '@angular/router';
import { LoggerService } from '../../../../shared/services/logger.service';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  styleUrls: ['./consent.component.scss'],
  standalone: false,
})
export class ConsentComponent {
  private consentService = inject(ConsentService);
  private router = inject(Router);
  private loggerService = inject(LoggerService);
  
  consentSettings = signal<ConsentSettings>({
    analytics: false,
    necessary: true, // Always true, cannot be disabled
  });

  async ngOnInit() {
    const consent = await this.consentService.getUserConsent();
    this.consentSettings.set(consent!.settings);
  }

  isLoading = signal<boolean>(false);

  async acceptAll() {
    this.consentSettings.set({
      analytics: true,
      necessary: true,
    });
    await this.saveConsent();

    this.loggerService.logEvent('Consent_all_accepted');
  }

  async acceptNecessary() {
    this.consentSettings.set({
      analytics: false,
      necessary: true,
    });
    await this.saveConsent();

    this.loggerService.logEvent('Consent_necessary_accepted');
  }

  async saveConsent() {
    this.isLoading.set(true);

    try {
      await this.consentService.saveUserConsent(this.consentSettings());
      this.router.navigate(['/home']);
    } catch (error) {
      this.loggerService.logException(error, 'Error saving consent');
      this.router.navigate(['/home']);
    } finally {
      this.isLoading.set(false);
    }
  }
}
